<template>
  <div style="width: 100%">
    <button
      type="button"
      class="box"
      style="justify-content: space-between"
      @click="expand = !expand"
      :class="{weekday_button_uncollapsed: expand}"
    >
      <b>{{ $t('cms.campaign.delay.Label') }}</b> <b>{{ selectedText }}</b>
    </button>

    <collapse :value="expand" class="fast" id="weekday_collapse">
      <label
        v-for="day in this.$CONSTANTS.campaignDelayOptions"
        :key="day.value"
        class="day_checkbox_row"
        :style="`font-weight: ${value === day.value ? 800 : 300}`"
      >
        {{day.name}}
        <div>
          <input
            class="weekday_checkbox"
            type="radio"
            :value="day.value"
            @click="$emit('input', day.value)"
          />
          <icon v-if="value === day.value" tick :size="20"/>
        </div>
      </label>
    </collapse>
  </div>
</template>

<script>
import { captureException } from '../../../plugins/debugging';

export default {
  props: {
    value: { type: String },
  },

  data() {
    return {
      expand: false,
    };
  },

  computed: {
    selectedText() {
      try {
        const value = this.value || '';
        return this.$CONSTANTS.campaignDelayOptions.find(v => v.value === value).name;
      } catch (e) {
        captureException(e);
        return this.$CONSTANTS.campaignDelayOptions[0].name;
      }
    },
  },
};
</script>
